/* eslint semi:0 */
import BaseVm from './BaseVm'

class ModalVm extends BaseVm {
  onChange() {
    let { modal, isModalOpen, currentComponent } = this
    if (isModalOpen) {
      modal.show(currentComponent)
    } else {
      modal.close()
    }
    super.onChange()
    return this
  }

  get modal() {
    return this.store.modal
  }

  get currentComponent() {
    return this.store.currentComponent
  }

  get isModalOpen() {
    return this.store.isModalOpen
  }
}

export default ModalVm



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/ModalVm.js